<template>
  <Card class="card p-5 shadow-sm" :title="$t('events.nps.statistics')">
    <div class="row px-10 py-5">
        <div v-if="Object.keys(statistics)?.length > 0 && !getting" class="justify-content-center  row">
            <h2>{{ $t("nps.customerSatisfaction") }}</h2>
            <br> <br> <br>
            <div class="d-flex justify-content-between">
              <h4>{{ nps?.nps_description }}</h4>
              <span class="fs-3 badge badge-light-primary">{{total}} {{ $t("nps._responses") }}</span>
            </div>

            <br><br>
            <div class="justify-content-center align-items-center back p-10 w-500px">
              <h2 class="text-primary text-center">{{ $t("nps.npsNote") + '  ('  }} {{ parseFloat(statistics.nps_score).toFixed(2) + ')' }}</h2>
              <br>
              <canvas id="nps_score_chart"></canvas>
            </div>
            <br><br><br><br><br><br>
            <br><br><br><br><br><br>

            <canvas id="kt_nps_chart" class="mh-400px"></canvas>
        </div> 
        <div v-if="Object.keys(statistics)?.length == 0 && !getting">
            <Card class="card p-5 h-full">
                <div class=" text-center ">
                    <div class="pt-8 ">
                      <Img filename="empty.png" alt=""
                        class="mw-100 h-125px h-sm-175px" />
                    </div>
                    <h2 class="fs-2x fw-bolder mb-0">{{ $t('events.nps.noNpsResponseReceived') }}</h2>
                    <br>
                    <br>
                    <Button btn-class="btn-md" type="new" btn-text="nps.send_invitation" @click="handleSendInvitation"/>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </Card>
        </div>
    </div> 
  </Card> 
  <NpsInvitationModal id="send_nps_invitation"/>
</template>

<script setup>
import {nextTick, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import NpsInvitationModal from "../../components/Modal/NpsInvitationModal.vue";
import abilities from "@/composables/abilities";
import {useHasAbility} from "@/composables/hasAbility";
import Img from "@/components/Img.vue";

const route = useRoute()
const store = useStore()
const { can } = useHasAbility()

const statistics = ref({})
const nps = ref({})
const total = ref(0)
const score = ref(0)
const getting = ref(false)

watch(() => route.params.nps, () => {
  if(route.params.nps){
    loadNps()
  }
})

watch(() => route.query.tab, (value) => {
  if(value == 'tab-nps' && route.params.nps) {
    loadNps()
    loadNpsStatistics()
  }
})

const loadNps= () => {
  getting.value = true
  store.dispatch('eventNps/getNps', route.params.nps).then((resp) => {
    nps.value = resp.data.data
  })
  .finally(() => getting.value = false)
}

async function loadNpsStatistics() {
    getting.value = true;
    try {
      const resp = await store.dispatch('eventNps/getNpsStatistics', route.params.nps);

      total.value = resp.data.statistics.total_response;
      if(resp.data.statistics.statistics_detail_nps?.length>0){
        score.value = resp.data.statistics.statistics_detail_nps[0]?.nps_score;
        statistics.value = resp.data.statistics.statistics_detail_nps[0];

        nextTick(() => {
          initChart([
            statistics.value.detractors,
            statistics.value.neutrals,
            statistics.value.promoters
          ]);
        })
      }
    } catch (error) {
      console.error('Error fetching NPS data:', error);
    } finally {
      getting.value = false;
    }
} 

const handleSendInvitation = () => {
   $('#send_nps_invitation').modal('toggle')
}

function initChart(values) {
  let ctx = document.getElementById('kt_nps_chart');
  if (!ctx) {
      console.error("Impossible d'obtenir le contexte 2D du canvas.");
  } else {
      // Définition d'une seule couleur pour toutes les barres
      var barColor = KTUtil.getCssVariableValue('--bs-primary') || '#007bff'; 

      // Données pour le graphique
      const data = {
          labels: ['Détracteurs', 'Neutres', 'Promoteurs'], // Chaque catégorie aura sa propre barre
          datasets: [
              {
                  label: 'NPS',
                  data: values ?? [10, 20, 5], // Valeurs correspondantes
                  backgroundColor: barColor, // Même couleur pour toutes les barres
                  borderColor: barColor,
                  borderWidth: 1
              }
          ]
      };

      // Configuration du graphique
      const config = {
          type: 'bar',
          data: data,
          options: {
              plugins: {
                  title: {
                      display: true,
                      text: 'Répartition des Détracteurs, Neutres et Promoteurs'
                  }
              },
              responsive: true,
              scales: {
                  x: {
                      grid: {
                          display: false
                      }
                  },
                  y: {
                      beginAtZero: true
                  }
              }
          }
      };

      // Initialisation du graphique
      var myChart = new Chart(ctx, config);
  }

}

const getNpsColor = (score) => {
  if (score <= 0) return "#FF4B4B"; // Rouge (mauvais)
  if (score <= 30) return "#FFA500"; // Orange (moyen)
  if (score <= 70) return "#FFD700"; // Jaune (bon)
  return "#00C851"; // Vert (excellent)
};

const drawChart = () => {
  let ctx = document.getElementById('nps_score_chart');
  
  if (ctx) {
    const safeValue = Math.max(1, Math.abs(score.value));
    let scoreChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        datasets: [
          {
            data: [Math.max(0, safeValue+ 100), Math.max(0, 100 - safeValue)], // Conversion du score NPS (-100 à 100) en valeurs positives
            backgroundColor: [getNpsColor(parseInt(score.value)), "#E0E0E0"], // Remplissage + couleur de fond
            borderWidth: 0,
            circumference: 180, // Demi-cercle
            rotation: -90, // Départ à gauche
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2.5, // Réduit la hauteur
        cutout: "80%", // Mince le donut
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
      },
    });
  }

  
};

watch(() => score.value, () => {
  nextTick(() => {
    drawChart()
  })
});


onMounted(async() => {
  if(route.params.nps && route.query.tab == 'tab-nps'){
    loadNpsStatistics()
    loadNps()
  }
})

</script>
<style scoped>
.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 5px;
  width: auto;
}
</style>
